import React from "react";
import { Table } from "semantic-ui-react";
import { SERVICES_BASE_URL } from "../../../utils/Constants";

const InvoiceItemsTable = ({ invoiceItems }) => {
  return (
    <Table celled basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Sku</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
          <Table.HeaderCell>Artikel</Table.HeaderCell>
          <Table.HeaderCell>Antal</Table.HeaderCell>
          <Table.HeaderCell>Vikt</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {invoiceItems.map((si, key) => {
          return (
            <Table.Row key={key}>
              <Table.Cell>
                <a href={si.backOfficeURL} target="_blank" rel="noopener noreferrer">
                  {" "}
                  {si.skuId}{" "}
                </a>
              </Table.Cell>
              <Table.Cell>
                <img
                  className="article-image-small"
                  src={
                    si.skuId < 70000000
                      ? si.imageUrl
                      : `${SERVICES_BASE_URL}/images/logo-rx.png`
                  }
                  alt="bild"
                  onError={(e, t) => (e.currentTarget.src = "https://placehold.co/280x280")}
                />
              </Table.Cell>
              <Table.Cell>{si.description}</Table.Cell>
              <Table.Cell>{si.invoicedQuantity}</Table.Cell>
              <Table.Cell>{`${si.weight} g`}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

export default InvoiceItemsTable;
